import {
  Text,
  Breakpoints,
  styled,
} from '@volkswagen-onehub/components-core';

export const StyledTyreItemSummary = styled.div(
  ({ theme }) => `
    display: grid;
    grid-template-columns: 40px 1fr 1fr;
    gap: ${theme.size.static300};
    padding-top: ${theme.size.static250};
    padding-bottom: ${theme.size.static100};
    cursor: pointer;
    position: relative;
    border-top: 1px solid rgb(192, 192, 192);
  
    @media(min-width: ${Breakpoints.b960}px) {
      grid-template-columns: 85px 1fr 1fr;
  
    }
  
    &:hover {
      background: rgb(225, 230, 234);
  
      svg {
          opacity: 1;
      }
    }
  
    &:last-child {
      border-bottom: 1px solid rgb(192, 192, 192);
    }
      
  `
);

export const StyledChevron = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;

  svg {
    opacity: 0;
  }
`;

export const TyreInformationDisclaimerText = styled(Text)(
  ({theme}) => `
  color: ${theme.colors.content.secondary};
`);

export const StyledStats = styled.div(
  ({theme}) => `
  color: ${theme.colors.content.secondary};
`);

export const StyledTyreTypeIdentifier = styled.div(
  ({theme}) => `
  color: ${theme.colors.content.active};
`);

export const StyledTyreInformationDetailsList = styled.ul`
  padding: 0;
  margin: 0;
`;

export const StyledTyreInformationDetailsItem = styled.li(
  ({ theme }) => `
  border-bottom: 1px solid rgb(225, 230, 234);
  color: rgb(14, 14, 14);
  display: grid;
  grid-template-columns: 1fr auto;
  padding-bottom: ${theme.size.static200};
  margin: ${theme.size.static200} 0;
`
);
